<template>
  <div class="tinymce-boxz">
    <div class="form_l">
      <el-input
        size="small"
        v-model="formData.schedule_id"
        placeholder="比赛id(必填)"
      ></el-input>
    </div>
    <Editor ref="editor" :content_s="content_s" />
    <el-button type="primary" @click="editor_fn">确定</el-button>
    {{ formData.content }}
  </div>
</template>

<script>
import Editor from './cpn/release_cpn.vue'
import { ref, reactive, getCurrentInstance, inject } from 'vue'
// import { useRouter } from 'vue-router'
export default {
  props: ['AUTH_OBJ', 'token'],
  components: {
    Editor
  },
  setup() {
    // 刷新
    const refresh = inject('reload')
    let { proxy: _this } = getCurrentInstance()
    // let router = useRouter()
    // let qs = require('qs')
    let formData = reactive({
      schedule_id: '',
      content: ''
    })
    let editor = ref(null)
    let content_s = ref(false)
    let from_fn = async () => {
      let reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
      let bbb = editor.value.content
      formData.content = bbb
        .replace(reg, 'javascript:;')
        .replace(/target="_blank"/g, '')
      if (formData.schedule_id == '' || formData.content == '') {
        _this.$notify({
          title: '提示',
          message: '不得为空',
          type: 'error'
        })
        return
      }
      let data = new FormData()
      for (let i in formData) {
        data.append(i, formData[i])
      }
      try {
        let res = await _this.$http.post(
          `/auth/user/release_match_report`,
          data
        )
        if (res.code == 200) {
          formData.schedule_id = ''
          formData.content = ''
          content_s.value = true
          _this.$notify({
            title: '提示',
            message: res.data.message,
            type: 'warning'
          })
          refresh()
        }
      } catch (error) {
        console.log(error.response)
        _this.$notify({
          title: '服务器错误',
          message: error.response.data.message,
          type: 'error'
        })
      }
    }
    // 上传点击
    let editor_fn = () => {
      from_fn()
    }
    return {
      editor,
      editor_fn,
      formData,
      content_s
    }
  }
}
</script>
<style scoped lang="less">
.tinymce-boxz > textarea {
  display: none;
}
.form_l {
  .el-input {
    width: 30%;
    margin: 10px 20px 10px 0;
  }
}
.el-button {
  float: right;
  margin: 10px;
}
</style>
